module.exports = __webpack_public_path__ + "static/img/contact.a0e09c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/contact.png
// module id = 0rda
// module chunks = 36